import { getRequest, postRequest, getcontractIdNumber } from './api'

export async function list(size, index, searchTerm, orderBy) {
  searchTerm = searchTerm || '%20';
  orderBy = orderBy || '%20';
  if (!searchTerm.includes('ContractID'))
    searchTerm = `${searchTerm}, ContractID:${getcontractIdNumber()},`
  return getRequest(
    `contactPerson/get-list/${parseInt(size, 10) || 10}/${parseInt(index, 10) || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`,
  )
}

export async function find(id) {
  return getRequest(`contactPerson/edit/${id}`)
}

export async function save(values) {
  return postRequest(`contactPerson/save`, values)
}

export function remove(values) {
  return postRequest(`contactPerson/delete`, values)
}

export const findWorkType = number => {
  if (number === null || number === undefined || number === 0) {
    return '-'
  }

  switch (number) {
    case 1:
      return 'workType1'
    case 2:
      return 'workType2'
    case 3:
      return 'workType3'
    default:
      return ''
  }
}
